import { ReactNode } from 'react';

export enum ProductModule {
    HOT = 'HOT',
    HOT2 = 'HOT2',
    NORMAL = 'NORMAL',
    NORMAL2 = 'NORMAL2',
    MEMBER = 'MEMBER',
    BUNDLE = 'BUNDLE',
    POPULAR = 'POPULAR',
    REFURBISH = 'REFURBISH',
    REFURBISH2 = 'REFURBISH2',
    FLASH_SALE = 'FLASH_SALE',
    ACCESSORY = 'ACCESSORY',
    ACCESSORY2 = 'ACCESSORY2',
    BUY_ONE_GET_ONE = 'BUY_ONE_GET_ONE',
    BUY_ONE_GET_ONE2 = 'BUY_ONE_GET_ONE2',
    PPS_SG = 'PPS_SG',
    PPS_SG2 = 'PPS_SG2',
    BEST_SELLERS = 'BEST_SELLERS',
    BEST_SELLERS2 = 'BEST_SELLERS2',
    BEST_RECOMMEND = 'BEST_RECOMMEND',
    ECO_CREDITS = 'ECO_CREDITS',
    CAMPING_PRATERS = 'CAMPING_PRATERS',
    HOME_BACKUP = 'HOME_BACKUP',
    MONTHLY_SELEC = 'MONTHLY_SELEC',
    BATTERY_SET = 'BATTERY_SET',
    ECOLOGY = 'ECOLOGY',
    SINGLE = 'SINGLE',
}

export type ILockInfo = {
    points: string;
    unLock: boolean;
} | null;

export enum IPageStatus {
    NOTSTARTED = 'notStarted',
    TEASER = 'teaser',
    ACTIVITY = 'activity',
    END = 'end',
}

export type ITimeLine = {
    teaser: {
        start: number;
        end: number;
    };
    activity: {
        start: number;
        end: number;
    };
};

export interface IProductProps {
    module: ProductModule;
    icon: ReactNode;
    title: string;
    desc: string;
    id?: string;
    isNeedBtn?: boolean;
}

export type IUserLevelInfo = {
    level: number;
    name: string;
    normalName: string;
    plusName: string;
    minPoint: number;
    validStartTime: string;
    validEndTime: string;
};

export type IProductItem = {
    id: string;
    discountPercent: string;
    disparityPrice: string;
    compareAtPrice: string;
    compareAtPrice2: string; // 手动设置
    imageUrl: string;
    imagePublic: {
        pc: string;
        h5: string;
    } | null; // 手动设置
    memberPrice: string;
    memberPrice2: string; // 手动设置
    price: string;
    price2: string; // 手动设置
    points: number;
    productId: string;
    purchaseUrl: string;
    productUrl: string;
    subtitle1: string;
    subtitle2: string;
    title: string;
    variantId: string;
    inventoryQuantity: number;
    displayInventoryQuantity: number;
    checkoutNode?: string;
    discount?: string;
    pointsMultiple: string;
    products?: {
        title: string;
        series: string;
    }[];
    category?: string;
};

export type IProductItem2 = IProductItem & {
    productPosition: number;
    points2: string | number;
};
